/**
 * Where a waiting-client video visit alert leads (2026-10-22): the assessor's
 * opens the visit in its own window, ready to join; the booker's and the
 * supervisor's open DA Scheduling or Appointments. Only these known paths are
 * followed, whatever the notification's data says.
 */
const TEMPLATE = 'visit_video_client_waiting';
const SESSION_LINK = /^\/telehealth-session\?sessionId=[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const PAGE_LINKS = Object.freeze(['/admin/da-scheduling', '/admin/appointments']);

/** @returns {{href: string, newWindow: boolean, label: string}|null} */
export function videoVisitAlertLink(notification) {
  if (notification?.templateId !== TEMPLATE) return null;
  const url = notification?.data?.url;
  if (typeof url !== 'string') return null;
  if (SESSION_LINK.test(url)) return { href: url, newWindow: true, label: 'Open the visit' };
  if (PAGE_LINKS.includes(url)) return { href: url, newWindow: false, label: url === PAGE_LINKS[0] ? 'Open DA Scheduling' : 'Open Appointments' };
  return null;
}

/** Opens the video visit window the way the DA board does. */
export function openVideoVisitWindow(href) {
  window.open(href, '_blank', 'width=1100,height=800');
}
